import React from 'react';
import { Link } from 'react-router-dom';

interface ServiceCardProps {
  title: string;
  result: string;
  description: string;
  outcomes: string[];
  index?: number;
  learnMoreLink?: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  result,
  description,
  outcomes,
  index = 0,
  learnMoreLink,
}) => {
  return (
    <div
      className="card-hover flex flex-col h-full bg-white dark:bg-neutral-dark-200 rounded-xl p-8 shadow-lg dark:shadow-xl dark:shadow-neutral-dark-400/20 border border-neutral-200 dark:border-neutral-dark-400 fade-in-up"
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      {/* Service Title */}
      <h3 className="text-xl font-semibold text-primary-indigo dark:text-primary-indigo mb-4">
        {title}
      </h3>

      {/* Result Statement - Focus on outcome */}
      <p className="text-lg font-semibold text-neutral-800 dark:text-neutral-dark-800 mb-4">
        {result}
      </p>

      {/* Description - Problem and solution */}
      <p className="text-neutral-600 dark:text-neutral-dark-600 mb-6 leading-relaxed">
        {description}
      </p>

      <div className="space-y-3 mb-6 flex-grow">
        {outcomes.map((outcome, outcomeIndex) => (
          <div key={outcomeIndex} className="flex items-start">
            <svg
              className="w-5 h-5 text-accent-emerald mr-2 mt-0.5 flex-shrink-0"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span className="text-sm text-neutral-700 dark:text-neutral-dark-700">
              {outcome}
            </span>
          </div>
        ))}
      </div>

      {/* CTA Button */}
      {learnMoreLink ? (
        <Link
          to={learnMoreLink}
          className="btn-hover mt-auto w-full px-6 py-3 bg-primary-indigo text-white rounded-lg font-medium hover:bg-primary-indigo/90 focus:outline-none focus:ring-2 focus:ring-primary-indigo focus:ring-offset-2 transition-all text-center inline-block"
          aria-label={`Learn more about ${title}`}
        >
          Learn More
        </Link>
      ) : (
        <button
          className="btn-hover mt-auto w-full px-6 py-3 bg-primary-indigo text-white rounded-lg font-medium hover:bg-primary-indigo/90 focus:outline-none focus:ring-2 focus:ring-primary-indigo focus:ring-offset-2 transition-all"
          aria-label={`Learn more about ${title}`}
        >
          Learn More
        </button>
      )}
    </div>
  );
};

export default ServiceCard;
